import template from './template.html'
import controller from './lockKnockButtons.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    storyObj: '<',
    lockObj: '<',
  },
  controller,
  controllerAs: 'vm',
}
